export default {
  dbb_explore_title: 'Benchmark Explorer',
  dbb_explore_title_explain: 'Explore industry benchmarks to evaluate your performance and identify potential improvements.',
  dbb_explore_metric_all: 'All',
  dbb_explore_metric_kpi: 'KPI',
  dbb_explore_metric_marketing: 'Marketing',
  dbb_explore_metric_technical: 'Technical',
  dbb_explore_metric: 'Metric',
  dbb_explore_metric_top_10_percent: 'Top 10%',
  dbb_explore_metric_median: 'Median',
  dbb_explore_metric_otdr: 'GTDR',
  dbb_explore_type_all: 'All',
  dbb_explore_type_shooter: 'Shooter',
  dbb_explore_type_soc: 'SOC',
  dbb_explore_type_rpg: 'RPG',
  dbb_explore_type_mmo: 'MMO',
  dbb_explore_type_casual: 'Casual',
  dbb_explore_recommended_questions: 'Recommended Questions',
  dbb_explore_recommended_genre: 'Recommended Genre',
  dbb_explore_footer_explain: 'Get game industry benchmarks from anonymized real game data and over 100 external sources like Mscience, VGInsight, GSD and Data.ai. Contact sallyxue@tencent.com for any questions.',
  dbb_explore_metric_filter: 'Genre filter',
  dbb_explore_total: '',
  dbb_explore_records: 'records',
  dbb_explore_search: 'Search',
  dbb_explore_search_no_match: 'No match found',
  dbb_explore_search_fail: 'Search failed',
  dbb_explore_search_loading: 'Loading...',
  dbb_explore_search_input_error_length: 'Maximum limit is 50 characters.',
  dbb_explore_search_input_error_special_char: 'Please enter valid characters. Only Chinese, English letters, numbers, spaces, &, -, (, ), $, % and / are supported',
  dbb_explore_search_placeholder: 'Please enter a metric (e.g Retention)',
  dbb_explore_search_no_found: 'NO METRICS FOUND',
  dbb_explore_search_no_found_explain: 'Sorry, it seems this metric has no corresponding benchmark. \n\rPlease try another metric.',
  dbb_explore_table_detail: 'Details',
  dbb_explore_feedback_unlike_placeholder: 'Please briefly describe why you dislike this feature:',
  dbb_explore_feedback_unlike_title: "We're sorry to hear that this benchmark data wasn't helpful to you. Please let us know your specific thoughts and suggestions so we can improve.",
  dbb_explore_metrics_table_reset: "Reset",
  dbb_explore_pc_console_system: 'PC/Console',
  dbb_explore_mobile_system: 'Mobile',
};